export default "__VITE_ASSET__b0465649__"